import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Spin,
  DatePicker,
  Row,
  Col,
  Button,
  Input,
  Icon,
  Empty,
  Typography,
} from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import {
  getPaginatedLiveCallsFromToStartDate,
  liveCallsSearch,
} from "../../services/liveCall/LiveCallService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import moment from "moment";

import { Translation } from "react-i18next";
import i18next from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
const { RangePicker } = DatePicker;
const { Text } = Typography;
function ListLiveCalls(props) {
  moment.locale("en");
  const firstPageIndex = 1;
  const [lang, setLang] = useState(
    props.context.curr_lang === "ar" && props.context.curr_dir === "rtl"
      ? "ar"
      : "en"
  );
  let [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  let [pagination, setPagination] = useState({
    current: firstPageIndex,
    pageSize: 10,
    total: 0,
  });
  let [calls, setCalls] = useState([]);
  let [searchText, setSearchText] = useState("");
  let [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [dateRange, setDateRange] = useState({
    from: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
    to: moment().format("YYYY-MM-DD HH:mm:ss").toString(),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    setSearchText(selectedKeys[0] ? selectedKeys[0] : searchText);
    setSearchedColumn(dataIndex);
    fetchFilteredData(
      firstPageIndex,
      pagination.pageSize,
      searchText,
      dataIndex
    );
  };
  const fetchFilteredData = async (
    page,
    pageSize,
    searchText,
    searchedColumn
  ) => {
    try {
      setIsFetching(true);
      const { from, to } = dateRange;

      let data = await liveCallsSearch(
        props.context.session_id,
        from,
        to,
        page,
        pageSize,
        searchedColumn === "anumber" ? searchText : "",
        searchedColumn === "bnumber" ? searchText : "",
        searchedColumn === "cnumber" ? searchText : ""
      );
      setCalls(data.ivrList);
      setPagination((prev) => ({
        ...prev,
        total: data.totalRecords,
        current: page,
        pageSize: pageSize,
      }));
      setIsFetching(false);

      console.log("Search RESPONE --DATA", data);
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
    getAllCalles(firstPageIndex, pagination.pageSize);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value ? [e.target.value] : []);
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) => {
      const fieldValue = record[dataIndex];
      return (
        fieldValue &&
        fieldValue.toString().toLowerCase().includes(value.toLowerCase())
      );
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
  });

  useEffect(() => {
    if (searchText === "") {
      getAllCalles(pagination.current, pagination.pageSize);
    }
  }, [pagination.current, pagination.pageSize, dateRange]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    if (searchText !== "") {
      fetchFilteredData(
        pagination.current,
        pagination.pageSize,
        searchText,
        searchedColumn
      );
    }
  };

  const getAllCalles = async (page, pageSize) => {
    try {
      setIsFetching(true);
      const { from, to } = dateRange;
      console.log("FROM", from);
      console.log("TO", to);

      let data = await getPaginatedLiveCallsFromToStartDate(
        props.context.session_id,
        from,
        to,
        page,
        pageSize
      );
      setCalls(data.ivrList);
      setPagination((prev) => ({
        ...prev,
        total: data.totalRecords,
        current: page,
        pageSize: pageSize,
      }));
      setIsFetching(false);

      console.log("RESPONE --DATA", data);
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  const onOk = (dates) => {
    const from = dates[0].format("YYYY-MM-DD HH:mm:ss").toString();
    const to = dates[1].format("YYYY-MM-DD HH:mm:ss").toString();

    setDateRange({ from, to });
  };
  const columns = [
    {
      title: i18next.t("A number"),
      dataIndex: "anumber",
      key: "anumber",
      ...getColumnSearchProps("anumber"),
    },
    {
      title: i18next.t("B number"),
      dataIndex: "bnumber",
      key: "bnumber",
      ...getColumnSearchProps("bnumber"),
    },
    {
      title: i18next.t("C number"),
      dataIndex: "cnumber",
      key: "cnumber",
      ...getColumnSearchProps("cnumber"),
    },

    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
    },
    // {
    //   title: "Account ID",
    //   dataIndex: "accountId",
    //   key: "accountId",
    //   ...getColumnSearchProps("accountId"),
    // },
    {
      title: "Switch Time",
      dataIndex: "switchTime",
      key: "switchTime",
      // ...getColumnSearchProps("switchTime"),
    },
  ];

  return (
    <Translation>
      {(t) => (
        <Page title={t("Live Calls")}>
      
          {isFetching ? (
            <Spin></Spin>
          ) : (
            <div>
              <Table
                className="components-table-demo-nested"
                columns={columns}
                dataSource={calls}
                rowKey="cdrId"
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                }}
                loading={isFetching}
                onChange={handleTableChange}
                bordered
                locale={{
                  emptyText: (
                    <Empty
                      description={i18next.t("Empty")}
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  ),
                }}
              />
            </div>
          )}
        </Page>
      )}
    </Translation>
  );
}
export default withSharedStateConsumer(ListLiveCalls);
